import * as React from "react";

function SvgLeft(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" {...props}><path d="M2.9 3h2v14h-2zM17.1 9.4v1.2H8.5l1.3 1.3L9 13l-3-3 3-3 .8 1.1-1.3 1.3h8.6z" /></svg>;
}

export default SvgLeft;